import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import Vehicle from "../../../classes/Vehicle";

export default {
  routes: [
    {
      name: "vehicles",
      path: "vehicles/:filter?",
      meta: {
        auth: () => Vehicle.canBeViewedBy(store.state.main.user),
        icon: "vehicles",
        title: i18n.global.tc("Vehicle", 100),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/employee/Vehicles"),
    },
  ],

  dialogs: [
    {
      name: "vehicle-new",
      path: "/vehicles/new/:type",
      meta: {
        auth: () => Vehicle.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/VehicleEdit"),
    },
    {
      name: "vehicle-edit",
      path: "/vehicles/:vehicleID/edit",
      meta: {
        auth: () => Vehicle.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/VehicleEdit"),
    },
  ],
};
